import { render, staticRenderFns } from "./AttivitaBachecaList.vue?vue&type=template&id=55b0b93a&scoped=true"
import script from "./AttivitaBachecaList.vue?vue&type=script&lang=js"
export * from "./AttivitaBachecaList.vue?vue&type=script&lang=js"
import style0 from "./AttivitaBachecaList.vue?vue&type=style&index=0&id=55b0b93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0b93a",
  null
  
)

export default component.exports